<div class="contact-search-flyout-wrapper showIt" *ngIf="flyout">
  <div class="contact-search-flyout">
    <div class="contact-form-wrapper">
      <form name="contactSearchForm" #contactSearch="ngForm" novalidate class="pad-5">
        <button type="button" class="btn btn-icon btn-people" (click)="toggleFlyout()">
          <i class="fa fa-male fa-stack-2x"></i>
        </button>
        <div class="control-label control-label-error" style="color:#f75b5b" *ngIf="!isOneFieldEntered()">Please fill in at least one search criterion.</div>
        <label class="visually-hidden">Name</label>
        <div class="row">
          <div class="form-group col-sm-6">
            <input type="text" class="form-control input-sm" id="contactFirstName" name="firstName" placeholder="First Name"
                   [(ngModel)]="contactQuery.firstName" autocomplete="off" />
          </div>
          <div class="form-group col-sm-6">
            <input type="text" class="form-control input-sm" id="contactLastName" name="lastName" placeholder="Last Name"
                   [(ngModel)]="contactQuery.lastName" autocomplete="off" />
          </div>
        </div>
        <div class="form-group">
          <input type="text" class="form-control input-sm" id="contactSSO" name="sso" placeholder="SSO" [(ngModel)]="contactQuery.sso" autocomplete="off" />
        </div>
        <div class="form-group">
          <input type="text" class="form-control input-sm" id="contactperNer" name="perNer" placeholder="PerNer" [(ngModel)]="contactQuery.perNer" autocomplete="off" />
        </div>
        <div class="form-group">
          <input type="text" class="form-control input-sm" id="subSegment" name="businessSubSegment" placeholder="Business Sub-segment"
                 [(ngModel)]="contactQuery.businessSubSegment" autocomplete="off" />
        </div>
        <div class="form-group d-flex">
          <button type="submit" class="btn btn-secondary btn-sm" (click)="searchContacts(contactSearch.valid)">
            Search
          </button>
          <button type="reset" class="btn btn-default btn-sm" (click)="reset()">Reset</button>
          <a class="talent-contact-search-createnew btn-link float-end ms-auto"  authenticate-user="Contact.CreateNew.Retrieve"  (click)="openAddContactModal();">Create New</a>
          <!--authenticate-user="Contact.CreateNew.Retrieve"-->
        </div>
      </form>
    </div>
    <div class="contact-results-wrapper">
      <div class="contact-card-wrapper pad-5" *ngIf="hasSearchResults">
        <div class="container-fluid">
          <div class="row" cdkDropList [cdkDropListData]="contacts.items">
            <div class="col-sm-6" *ngFor="let contact of contacts.items">
              <div class="contact-card">
                <div class="contact-avatar">
                  <img cdkDrag [cdkDragData]="contact" src="/assets/image/contact/{{contact.imageId}}" style="width:30px;height:30px;" />
                </div>
                <div class="contact-name btn-link">
                  <!--SCOR-25967 Autheticate commands removed, Anchor links should be clicable for all users-->
                  <!-- <a href="/scorepay/contact/{{contact.id}}" title="{{contact.firstName}} {{contact.lastName}}" target="_blank" authenticate-user="Contact_Profile_Header.Retrieve, contact_profile_profile_info.retrieve" authenticate-command="disableanchor">{{contact.firstName}} {{contact.lastName}}</a> -->
                  <a href="/scorepay/contact/{{contact.id}}" title="{{contact.firstName}} {{contact.lastName}}" target="_blank">{{contact.firstName}} {{contact.lastName}}</a>
                </div>
                <div class="position mt-0">
                  {{contact.subBusinessSegment}}
                </div>
                <div class="row">
                  <div class="col-md-10">
                    <div class="location" *ngIf="contact.sso">
                      <span>SSO:</span>{{contact.sso}}
                    </div>
                    <div class="location" *ngIf="!contact.sso && contact.perNer">
                      <span>PerNer:</span>{{contact.perNer}}
                    </div>
                    <div class="location country-{{contact.country|lowercase}}" *ngIf="contact.city || contact.state">
                      <span class="flag-icon flag-icon-{{ contact.country | lowercase }}"></span>
                      {{contact.city}}<span *ngIf="contact.city && contact.state">,</span> {{contact.province}}
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div *ngIf="contact.flaggedByhr" class="pull-right">
                      <span class='fa-stack fa-1x'><i class='fa fa-circle fa-stack-2x' style='color:red;'></i><i class='fa fa-warning fa-stack-1x' style='color:yellow;'></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
